<script lang="ts">
	import type { VoucherDetailProps } from "./VoucherDetailProps.js";
	import Layout from "../components/Layout.svelte";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import WeddingsBanner from "../components/Wedding/WeddingsBanner.svelte";
	import Branches from "../components/Branches.svelte";
	import voucherImage from "../../../core/assets/voucher.jpg";
	import Content from "../components/Content.svelte";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import { appName } from "../../../core/schema/names/appName.js";
	import VoucherCartForm from "../components/Voucher/VoucherCartForm.svelte";
	import VoucherStructuredData from "../components/Voucher/VoucherStructuredData.svelte";
	import { setContext } from "svelte";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";

	type $$Props = VoucherDetailProps;
	const { plannedIceCreams, voucher } = $$restProps as $$Props;

	const { TENANT_LOCALE } = getGlobalSettings();

	setContext(thumbnailImageContextKey, voucherImage);
</script>

<VoucherStructuredData {voucher} />

<Layout>
	<section>
		<div class="container">
			<h1 class="mb-8 mt-5 px-4 py-0 text-[1.5rem] font-semibold leading-8 md:!hidden md:text-xl md:leading-[3.25rem]">
				{nbspify(voucher.name[TENANT_LOCALE])}
			</h1>
		</div>
		<div class="flex justify-center">
			<div class="bg-secondary-40 group flex h-[17rem] w-[90%] items-center justify-center md:hidden">
				<StaticPicture
					alt="Logo {appName}"
					image={voucherImage}
					class="w-[17rem] opacity-80 transition-all duration-300 group-hover:opacity-100 md:hidden"
					loading="eager"
					width={600}
					height={600}
				/>
			</div>
		</div>
		<div class="container">
			<div class="mt-4 flex flex-col gap-28">
				<div class="flex flex-col md:grid md:grid-cols-2 md:gap-10">
					<div
						class="bg-secondary-40 group hidden aspect-square h-auto max-h-[37rem] w-full max-w-[37rem] items-center justify-center md:flex"
					>
						<StaticPicture
							alt="Logo {appName}"
							image={voucherImage}
							class="opacity-80 transition-all duration-300 group-hover:opacity-100"
							imgClass="rounded-lg"
							loading="eager"
							width={600}
							height={600}
						/>
					</div>

					<div>
						<div class="mb-8 flex flex-col items-start gap-3 md:gap-4">
							<h1
								class="m-0 hidden p-0 text-[1.5rem] font-semibold leading-8 md:inline-block md:text-xl md:leading-[3.25rem]"
							>
								{voucher.name[TENANT_LOCALE]}
							</h1>
						</div>

						<div class="mt-6 md:mb-[3rem] lg:mb-[12rem] xl:mb-[18rem]">
							<Content
								content={`Dárkový poukaz v hodnotě ${voucher.value} Kč. Po zaplacení objednávky obdržíte poukaz na vaší e-mailové adrese. Hodnotu poukazu je nutné vyčerpat najednou.`}
							/>
						</div>

						<VoucherCartForm {voucher} />
					</div>
				</div>
			</div>
		</div>
	</section>

	<div class="container">
		<section>
			<WeddingsBanner />
		</section>

		<section>
			<Branches {plannedIceCreams} />
		</section>
	</div>
</Layout>
